module.exports = __webpack_public_path__ + "img/bj_zanwu.bf6dc5f9.png";